<div
  *ngFor="let nav_item of getNavItems()"
  class="sp-margin__top"
  [ngClass]="navbar_status == open_navbar_status ? 'sp-padding__horiz-x2' : 'sp-row__center'">
  <div
    class="sp-padding sp-border-radius__xs sp-cursor__pointer sp-row__align"
    [ngClass]="getCurrentItemClass(nav_item)"
    (click)="onMenuItemClick(nav_item)">
    <mat-icon
      class="sp-color__accent-contrast sp-icon__min-width"
      [matTooltip]="nav_item.label || '' | translate">
      {{ nav_item.icon }}
    </mat-icon>
    <span
      *ngIf="navbar_status == open_navbar_status"
      class="sp-color__accent-contrast sp-margin__left">
      {{ nav_item.label || '' | translate }}
    </span>
  </div>
</div>
